import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import moment from "moment";
import countryList from "react-select-country-list";
import placeholder from "../../assets/images/userprofile.png";
import { blobToFile } from "../../utils/helpers";
import ImageCropper from "../../Component/ImageCropper";
import SkeletonLoader from "./skeltonLoader";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";

// Redux Toolkit imports
import {
  fetchUserProfile,
  fetchUniversityPartners,
  fetchIndustries,
  fetchProgramStudies,
  fetchUpdateProfileSettings,
  fetchAreas,
  fetchObjectives,
  fetchParticularPrograms,
  fetchLanguages,
  fetchExperience,
  updateProfileStep,
  clearStepFields,
} from "./Slice/updateProfileSliceNew";
import {
  fetchCoursesCompleted,
  fetchBoardExperienceMentor,
  fetchBoardEntityTypeExperience,
  fetchAccreditedDirector,
  fetchBoardExperienceLevel,
  fetchBoardExperience,
} from "../Authentication/Register/slice/registerSlice";
import {
  normalizeUpdateProfilePayload,
  buildUpdateProfileFormData,
  applyUserProfileData,
  handlePostProfileLoadEffects,
} from "./helpers/updateProfile/updateProfileDataHelpers";
import { renderUpdateProfileField, renderBoardRolesInline } from "./helpers/updateProfile/updateProfileFieldRenderers";
import PropTypes from "prop-types";

const UpdateProfileStep5 = (props) => {
  const dispatch = useDispatch();
  const history = useNavigate();

  // Redux state from the slice
  const {
    universityPartners: university_partners_list,
    industries: industry_list,
    programStudies: programStudyId,
    updateProfileStepFields: registerStepFields,
    areas,
    objectives: objective,
    particularPrograms: particularProgram,
    languages: languageOptions,
    experienceData: userExperience,
    programmes,
  } = useSelector((state) => state.updateProfile);

  // Board-related data from register slice
  const {
    coursesCompleted,
    boardExperienceMentor,
    boardEntityTypeExperience,
    accreditedDirector,
    boardExperienceLevel,
    boardExperience,
  } = useSelector((state) => state.register);

  // Component-specific loading state to prevent flash
  const [componentReady, setComponentReady] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Other Redux state
  const { setting } = useSelector((state) => state.setting);
  const { userInfo } = useSelector((state) => state.userInfo);
  const updateProfileData = useSelector((state) => state.updateProfileData);

  const { title, superUserParams } = props;
  const [dob, setDob] = useState(null);
  const { register, control, reset, clearErrors, trigger, handleSubmit, setValue, watch, formState, formState: { errors } } = useForm({
    defaultValues: superUserParams || {},
    mode: 'onChange',
    reValidateMode: 'onChange'
  });

  const [roleId, setRoleId] = useState('');
  const [checkBox, setCheckBox] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [showDateDiv, setShowDateDiv] = useState("none");
  const [experience, setExperience] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [emailVerifyString, setEmailVerifyString] = useState("");
  const [readOnly] = useState(false);
  const [industryData, setIndustryData] = useState("");
  const [{ alt, src }, setImg] = useState({
    src: placeholder,
    alt: "Upload an Image",
  });
  const [cropImg, setCropImg] = useState("");
  const [cropImgModalShow, setCropImgModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedFile, setSelectedFile] = useState("");
  const [userId] = useState(userInfo?.id);
  const options = countryList().getData();
  const [country] = useState(options);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [userData, setUserData] = useState({});
  const [defaultLanguages, setDefaultLanguages] = useState([]);
  const [languages, setLanguages] = useState([]);

  const [mainArea, setMainArea] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [experienceData] = useState([]);
  const [selectedObjective, setSelectedObjective] = useState([]);
  const [selectedResume, setSelectedResume] = useState("");
  const [resumeText, setResumeText] = useState("");
  const [text, setText] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [available, setAvailable] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [employee, setEmployee] = useState("yes");
  const [settingData, setSettingData] = useState([]);
  const [redirectPath, setRedirectPath] = useState(null);

  const customStyles = {
    menu: (base) => ({
      ...base,
      backgroundColor: "white",
      top: "32px",
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    }),
  };

  const countWords = (text) => {
    return text?.replaceAll("\r\n", "\n")?.length;

  };

  const getUniversityPartnerList = () => dispatch(fetchUniversityPartners());
  const getIndustryList = () => dispatch(fetchIndustries());
  const getProgramStudyId = () => dispatch(fetchProgramStudies());
  const registerSetting = (roleId1) => dispatch(fetchUpdateProfileSettings({ roleId: roleId1, stepKey: "step_5" }));
  const getAreasData = () => dispatch(fetchAreas());
  const getObjectiveData = (roleID) => dispatch(fetchObjectives(roleID));
  const getParticularProgram = () => dispatch(fetchParticularPrograms());
  const getLanguageList = () => dispatch(fetchLanguages());
  const getExperienceData = (_roleId) => dispatch(fetchExperience());

  const currentYear = new Date().getFullYear();
  const years = Array.from(new Array(currentYear - 1990 + 1), (val, index) => 1990 + index);

  const checkFromDate = (date) => {
    const formattedDate = moment(new Date(date)).format("YYYY-MM-DD");
    setFromDate(formattedDate);
    setValue("from_date", formattedDate);
  };

  const checkToDate = (date) => {
    const formattedDate = moment(new Date(date)).format("YYYY-MM-DD");
    setToDate(formattedDate);
    setValue("to_date", formattedDate);
  };


  const showDatePicker = (e) => {
    if (e.target.checked) {
      setAvailable(2);
      setShowDateDiv("block");
    } else {
      setAvailable(1);
      setShowDateDiv("none");
    }
  };

  const handleChange = (item) => {
    getExperienceData();
    setRoleId(item);

    // Fetch board-related data based on role
    if (item === "Mentor" || item === "Mentees") {
      dispatch(fetchCoursesCompleted());
      dispatch(fetchBoardExperience(item));
      dispatch(fetchBoardExperienceLevel(item));
      dispatch(fetchBoardEntityTypeExperience(item));
      dispatch(fetchAccreditedDirector(item));
      dispatch(fetchBoardExperienceMentor("Mentee")); // Always call with "Mentee" for board_entity_type_2
    }
  };

  const handleProgrammesChange = (item) => {
    if (item) {
      clearErrors("program_study_id");
    }
  };

  const handleGender = (value) => {
    setGender(value);
  };

  const setOrganizationPlaceholder = (e) => {
    setEmployee(e.target.value);
  };

  const siteName = setting?.name?.trim() || "Register Now as Mentor or Mentee";

  useEffect(() => {
    const title = `${siteName} - Register Now as Mentor or Mentee`;
    document.title = title;
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        `Register now with ${setting?.name} as a mentor or mentee to join the domain-specific career mentoring between women leaders and experienced industry leaders.`
      );
  }, [siteName, setting?.name]);

  useEffect(() => {
    getUniversityPartnerList();
    getIndustryList();
    getAreasData();
    getProgramStudyId();
    getParticularProgram();

    // Fetch settings data
    const fetchSettingsData = async () => {
      try {
        const settingResponse = await agent.get(API.SETTING);
        setSettingData(settingResponse?.data || []);
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };
    fetchSettingsData();
  }, [setting]);

  useEffect(() => {
    if (languageOptions.length === 0) {
      getLanguageList();
    }
  }, [languageOptions]);

  const onSubmit = async (data) => {
    const isValid = await trigger();
    if (!isValid) return;
    const normalizedPayload = normalizeUpdateProfilePayload({
      data: { ...data, step_number: "step_5" },
      roleId,
      available,
      fromDate,
      toDate,
      email_verify_string: emailVerifyString,
      selectedResume,
      selectedFile,
    });

    const formData = buildUpdateProfileFormData({
      data: normalizedPayload,
      registerStepFields,
      selectedFile,
    });

    setIsLoading(true);

    dispatch(updateProfileStep({
      params: formData,
      step: "step_5",
      userId: userId,
      redirectPath: null
    }))
      .unwrap()
      .then((response) => {
        setIsLoading(false);
        if (response.success) {
          setPopupMessage(response.message);
          setShowPopup(true);

          if (response.redirectTo) {
            setRedirectPath(response.redirectTo);
          }
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setPopupMessage(error.message || "Update failed");
        setShowPopup(true);
      });
  };

  const handlePopupOk = () => {
    setShowPopup(false);
    if (redirectPath) {
      dispatch(clearStepFields());
      history(redirectPath);
    }
  };

  const setSelectedMainAreaArray = (e, catId) => {
    if (document.querySelectorAll(".mainArea" + catId + ":checked").length > 0) {
      document.getElementById("mainArea" + catId).checked = true;
      document.getElementById("mainArea" + catId).classList.remove("is-invalid");
    } else {
      document.getElementById("mainArea" + catId).checked = false;
      document.getElementById("mainArea" + catId).classList.add("is-invalid");
    }
    const val = e.target.value;
    let cloneSelected = [...selectedArea];
    if (selectedArea.includes(val)) {
      cloneSelected = selectedArea.filter((item) => item !== val);
    } else {
      cloneSelected.push(val);
    }
    setSelectedArea(cloneSelected);
    /* SetMainArea keys */
    let cloneMainSelected = [...mainArea];
    if (document.querySelectorAll(".mainArea" + catId + ":checked").length == 0) {
      cloneMainSelected = cloneMainSelected.filter((item) => item != catId);
    } else {
      let newValue = catId.toString();
      if (!cloneMainSelected.includes(newValue))
        cloneMainSelected.push(newValue);
    }
    setMainArea(cloneMainSelected);
    /* SetMainArea keys */
  };


  const getSubcategoryIds = (areas, mainId) => {
    const area = areas.find((a) => a.id == mainId);
    return area ? area.subcategory.map((i) => i.id.toString()) : [];
  };

  const addMainArea = (mainArr, val) => [...mainArr, val];

  const removeMainArea = (mainArr, val) =>
    mainArr.filter((item) => item !== val);

  const addSubAreas = (selected, subIds) => [
    ...selected,
    ...subIds.filter((id) => !selected.includes(id)),
  ];

  const removeSubAreas = (selected, subIds) => {
    const removeSet = new Set(subIds);
    return selected.filter((id) => !removeSet.has(id));
  };

  const updateFormValues = ({
    updatedMainArr,
    updatedSubArr,
    setValue,
    clearErrors,
    trigger,
  }) => {
    setValue("domains", updatedMainArr);

    if (updatedSubArr.length > 0) {
      setValue("subarea", updatedSubArr);
      setValue("subareas", updatedSubArr);
    }

    if (updatedMainArr.length >= 1) {
      clearErrors("domains");
      clearErrors("mainArea");
    }

    trigger("domains");
  };


  const setSelectedMainCategoryArray = (e, mainAreaId) => {
    const val = e.target.value;
    const checkbox = document.getElementById("mainArea" + mainAreaId);
    const isChecked = checkbox.checked;

    let updatedMainArr = [...mainArea];
    let updatedSubArr = [...selectedArea];

    const subCategoryIds = getSubcategoryIds(areas, val);

    if (isChecked) {
      // limit of 3 main areas
      if (updatedMainArr.length >= 3) {
        checkbox.checked = false;
        return;
      }

      updatedMainArr = addMainArea(updatedMainArr, val);
      updatedSubArr = addSubAreas(updatedSubArr, subCategoryIds);
    } else {
      updatedMainArr = removeMainArea(updatedMainArr, val);
      updatedSubArr = removeSubAreas(updatedSubArr, subCategoryIds);
    }

    setMainArea(updatedMainArr);
    setSelectedArea(updatedSubArr);

    updateFormValues({
      updatedMainArr,
      updatedSubArr,
      setValue,
      clearErrors,
      trigger,
    });
  };



  const setSelectedObjectiveArray = (e) => {
    const val = e.target.value;
    let cloneSelected1 = [...selectedObjective];

    if (selectedObjective.includes(val)) {
      cloneSelected1 = selectedObjective.filter((item) => item !== val);
    } else {
      cloneSelected1.push(val);
    }

    setSelectedObjective(cloneSelected1);
  };

  const clearAll = () => {
    // Reset state arrays
    setMainArea([]);
    setSelectedArea([]);

    // Reset form values for controlled inputs
    setValue("mainArea", []);
    setValue("subarea", []);
    setValue("domains", []);

    // Optionally clear validation errors
    clearErrors("mainArea");
    clearErrors("subarea");
    clearErrors("domains");

    // Optionally re-trigger validation to update UI
    trigger("mainArea");
    setSelectedObjective([]);
    setValue("objective", []);     // reset field value in react-hook-form
    clearErrors("objective");      // clear the validation message
    trigger("objective");
  };

  const applyExperienceData = (data) => {
    if (!data?.experience_levels) return;

    const ids = data.experience_levels.map(item => item.id);
    setExperience(ids);

    // For checkbox implementation, set as array of IDs
    setValue("experience_levels", ids);
  };
  const applyDomainData = (data) => {
    const tempMain = data?.domains ? data.domains.split(",") : [];
    const tempSub = data?.subareas ? data.subareas.split(",") : [];

    setMainArea(tempMain);
    setSelectedArea(tempSub);

    setValue("mainArea", tempMain);
    setValue("subarea", tempSub);
    setValue("domains", tempMain);

    clearErrors("mainArea");
    clearErrors("domains");
  };

  const applyAvailabilityData = (data) => {
    setAvailable(data?.user_availability);

    if (data?.user_availability === 2) {
      setShowDateDiv("block");
      setValue("availability", true);
      checkFromDate(data.user_availability_check?.start_time);
      checkToDate(data.user_availability_check?.end_time);
      return;
    }

    setShowDateDiv("none");
    setValue("availability", false);
    setValue("from_date", null);
    setValue("to_date", null);
  };

  const applyLanguageData = (data) => {
    if (!data?.language) return;

    const selectedLanguages = data.language.split(",");

    setDefaultLanguages(
      languageOptions.filter((item) =>
        selectedLanguages.includes(item.value.toString())
      )
    );

    setLanguages(selectedLanguages);
    setValue("language", selectedLanguages);
  };

  const applyBasicProfileData = (data) => {
    setSelectedObjective(data?.objective ? data.objective.split(",") : []);
    setRoleId(data?.role_id);
    getObjectiveData(data?.role_id);
    registerSetting(data?.role_id);
    setEmailVerifyString(data?.email_verify_string);
    setText(data?.about);
    setDob(data?.dob);

    setResumeText(
      data?.resume ? data.resume.split("resume/")[1] : ""
    );
    setSelectedResume(data?.resume);

    if (data?.employee) setEmployee(data.employee);
    if (data?.gender) setGender(data.gender);
    if (data?.country) setSelectedCountry(data.country);
  };


  useEffect(() => {
    const getAreasDatas = async () => {
      try {
        const userIdToUse = updateProfileData?.id;
        if (!userIdToUse) return;

        const res = await dispatch(fetchUserProfile(userIdToUse)).unwrap();
        const data = res?.data;

        setUserData(data);

        const { image, resume, ...rest } = data;
        reset(rest);

        applyExperienceData(data);
        applyBasicProfileData(data);
        applyDomainData(data);
        applyAvailabilityData(data);
        applyLanguageData(data);

        setImg({
          src: data?.image || placeholder,
          alt: "Upload an Image",
        });

        setSelectedFile(data?.image);
        getExperienceData(data?.role_id);

        if (localStorage.getItem("student_img")) {
          setSelectedFile(
            blobToFile(
              localStorage.getItem("student_img"),
              `${updateProfileData?.id}.png`
            )
          );
        }

        // Skeleton loader delay
        setTimeout(() => {
          setComponentReady(true);
          setInitialDataLoaded(true);
        }, 300);

      } catch (err) {
        console.error("Error fetching user data:", err);
      }
    };

    if (updateProfileData?.id) {
      getAreasDatas();
    }
  }, [updateProfileData?.id]);


  useEffect(() => {
    if (experienceData?.length > 0) {
      setExperience(experienceData.map((item) => item.id));
    }
  }, [experienceData]);

  useEffect(() => {
    if (!updateProfileData?.id) {
      return;
    }

    dispatch(fetchUserProfile(updateProfileData?.id))
      .unwrap()
      .then((res) => {
        const userData = res.data;
        setUserData(userData);

        applyUserProfileData({
          userData,
          reset,
          setRoleId,
          setDob,
          setSelectedObjective,
          getObjectiveData,
          registerSetting,
          setEmailVerifyString,
          setText,
          setResumeText,
          setSelectedResume,
          setExperience,
          setValue,
          setMainArea,
          setSelectedArea,
          clearErrors,
          setImg,
          setAvailable,
          setShowDateDiv,
          checkFromDate,
          checkToDate,
          setSelectedFile,
          getExperienceData,
          setEmployee,
          setGender,
          setCountry: setSelectedCountry,
          languageOptions,
          blobToFile,
          placeholder,
          dispatch,
          fetchCoursesCompleted,
          fetchBoardExperience,
          fetchBoardExperienceLevel,
          fetchBoardEntityTypeExperience,
          fetchAccreditedDirector,
          fetchBoardExperienceMentor,
        });

        handlePostProfileLoadEffects({
          setComponentReady,
          setInitialDataLoaded,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }, [title, setting, updateProfileData?.id]);

  useEffect(() => {
    if (areas.length > 0 && userData?.domains) {
      const tempMain = userData.domains
        ? userData.domains.split(",").map(String)
        : [];
      const tempSub = userData.subareas
        ? userData.subareas.split(",").map(String)
        : [];

      setMainArea(tempMain);
      setSelectedArea(tempSub);
      setValue("mainArea", tempMain);
      setValue("subarea", tempSub);
      setValue("domains", tempMain);
    }
  }, [areas, userData]);

  const onChangePicture = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) {
      setImg({ src: placeholder, alt: "Upload an Image" });
      setIsLoading(true);
      return;
    }

    const allowedExtensions = ["jpg", "jpeg", "png"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      setPopupMessage("Please select valid image format (jpg, jpeg, png)");
      setShowPopup(true);
      return;
    }

    // ✅ 30 MB check (STANDARDIZED)
    const sizeInMB = file.size / (1024 * 1024);
    if (sizeInMB > 30) {
      setPopupMessage("Please select image size less than 30 MB");
      setShowPopup(true);
      setImg({ src: placeholder, alt: "Upload an Image" });
      return;
    }

    clearErrors("image");

    setImg({
      src: placeholder,
      alt: file.name,
    });

    setCropImg(URL.createObjectURL(file));
    setCropImgModalShow(true);
    setIsLoading(false);
  };

  const fileToImage = (childdata) => {
    const croppedFile = blobToFile(
      childdata,
      updateProfileData?.id + ".png"
    );

    setSelectedFile(croppedFile);
    setImg({
      src: URL.createObjectURL(childdata),
      alt: "",
    });

    setValue("image", croppedFile, {
      shouldDirty: true,
      shouldValidate: true,
    });

    trigger("image");
    setCropImgModalShow(false);
  };

  const onChangeResume = (e) => {
    if (e.target.files[0]) {
      const selectedResume = e.target.files[0];
      setSelectedResume(selectedResume);
      setResumeText(selectedResume.name);
      clearErrors('resume');
    }
  };

  const renderField = (field) =>
    renderUpdateProfileField(field, {
      control,
      register,
      errors,
      watch,
      setValue,
      clearErrors,
      trigger,
      formState,
      email,
      setEmail,
      readOnly,
      roleId,
      handleChange,
      handleProgrammesChange,
      programmes,
      programStudyId,
      university_partners_list,
      years,
      userExperience,
      experience,
      setExperience,
      country,
      country1: selectedCountry,
      userData,
      setCountry: setSelectedCountry,
      languageOptions,
      customStyles,
      industry_list,
      industryData,
      setIndustryData,
      particularProgram,
      checkBox,
      setCheckBox,
      checkBox2,
      setCheckBox2,
      available,
      showDateDiv,
      checkFromDate,
      checkToDate,
      fromDate,
      toDate,
      showDatePicker,
      onChangePicture,
      selectedFile,
      src,
      alt,
      resumeText,
      onChangeResume,
      mainArea,
      setMainArea,
      selectedArea,
      setSelectedArea,
      areas,
      selectedObjective,
      setSelectedObjective,
      objective,
      dob,
      setDob,
      countWords,
      setText,
      placeholder,
      selectedResume,
      employee,
      setOrganizationPlaceholder,
      gender,
      handleGender,
      setSelectedMainAreaArray,
      setSelectedMainCategoryArray,
      setSelectedObjectiveArray,
      clearAll,
      text,
      defaultLanguages,
      setDefaultLanguages,
      languages,
      setLanguages,
      // Board-related data
      coursesCompleted,
      boardExperienceMentor,
      boardEntityTypeExperience,
      accreditedDirector,
      boardExperienceLevel,
      boardExperience,
      setting: settingData?.data || setting,
      settingData,
      setResumeText,
      setSelectedResume,
      dispatch
    });

  useEffect(() => {
    if (selectedObjective.length > 0) {
      setValue("objective", selectedObjective);
      clearErrors("objective");
      trigger("objective");
    }
  }, [selectedObjective]);

  const parseNumberArray = (value) =>
    value.split(",").map((id) => Number.parseInt(id.trim()));

  const parseStringArray = (value) =>
    value.split(",").map((v) => v.trim());

  const applyBoardMultiSelectFields = (data) => {
    const numberFields = [
      "board_entity_type",
      "board_entity_type_2",
      "course_completed",
      "accredited_director",
      "indicate_board_experience_level"
    ];

    for (const field of numberFields) {
      if (data?.[field]) {
        setValue(field, parseNumberArray(data[field]));
        clearErrors(field);
      }
    }

    if (data?.past_board_roles) {
      setValue("past_board_roles", parseStringArray(data.past_board_roles));
      clearErrors("past_board_roles");
    }
  };

  const applyBoardSingleSelectFields = (data) => {
    const singleSelectBoardFields = ["years_of_board_experience"];

    for (const field of singleSelectBoardFields) {
      if (data?.[field]) {
        setValue(field, data[field].toString());
        clearErrors(field);
      }
    }
  };

  // Handle board field prefilling after board API data is loaded
  useEffect(() => {
    const hasUserData =
      userData &&
      Object.keys(userData).length > 0 &&
      (boardEntityTypeExperience?.length > 0 ||
        coursesCompleted?.length > 0 ||
        boardExperience?.length > 0);

    if (!hasUserData) return;

    applyBoardMultiSelectFields(userData);
    applyBoardSingleSelectFields(userData);

  }, [
    userData,
    boardEntityTypeExperience,
    coursesCompleted,
    boardExperience,
    boardExperienceLevel,
    accreditedDirector,
    setValue,
    clearErrors
  ]);

  return (
    <>
      {Object.keys(userData).length !== 0 && (
        <>
          <section>
            <Container>
              <Row className="align-items-center justify-content-center">
                <Col md={10}>
                  <div className="logininnerouter resetouter">

                    {(!componentReady || !initialDataLoaded || !registerStepFields || registerStepFields.length === 0) && <SkeletonLoader />}

                    <div style={{ display: (componentReady && initialDataLoaded && registerStepFields && registerStepFields.length > 0) ? 'block' : 'none' }}>

                      {registerStepFields?.length > 0 ? registerStepFields?.map((resp, index) => {
                        return (<div key={resp?.id || index} className="loginform" style={{ backgroundColor: 'white' }}>
                          <h1 className="domain-label" >{resp?.step_label}</h1>

                          <div className="steps_signup mb-5"  >
                            <div>
                              <span className="stepcount active">1</span>
                              <span className="stepcount active">2</span>
                              <span className="stepcount active">3</span>
                              <span className="stepcount active">4</span>
                            </div>
                          </div>

                          <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                              {(() => {
                                // Track which board role fields have been rendered
                                let renderedBoardRoleFields = new Set();

                                return (
                                  <>
                                    {resp?.reg_feilds?.map((field, fieldIndex) => {
                                      const boardRoleFieldKeys = ['rep_company_name', 'rep_board_title', 'rep_start_date', 'rep_end_date'];
                                      const isBoardRoleField = boardRoleFieldKeys.includes(field.reg_key);

                                      // Skip if already rendered as part of a group
                                      if (renderedBoardRoleFields.has(field.reg_key)) {
                                        return null;
                                      }

                                      // If this is the first board role field, render the entire group
                                      if (isBoardRoleField && field.reg_key === 'rep_company_name') {
                                        renderedBoardRoleFields.add('rep_company_name');
                                        renderedBoardRoleFields.add('rep_board_title');
                                        renderedBoardRoleFields.add('rep_start_date');
                                        renderedBoardRoleFields.add('rep_end_date');

                                        return (
                                          <React.Fragment key="board_roles_group">
                                            {renderBoardRolesInline(resp?.reg_feilds, {
                                              control,
                                              register,
                                              errors,
                                              watch,
                                              setValue,
                                              clearErrors,
                                              trigger,
                                              roleId,
                                              setting: settingData?.data || setting,
                                              formState,
                                            })}
                                          </React.Fragment>
                                        );
                                      }

                                      // Skip other board role fields (they're rendered as a group)
                                      if (isBoardRoleField) {
                                        return null;
                                      }

                                      // Render normal fields
                                      return (
                                        <React.Fragment key={field.reg_key || fieldIndex}>
                                          {renderField(field)}
                                        </React.Fragment>
                                      );
                                    })}

                                    <Col md={12}>
                                      <div className="form-group mt-3 text-center">

                                        <Button
                                          className="btn btn_red loginsubmit nextbtn outline me-2"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            history("/manage-profile-step3");
                                          }}
                                        >
                                          Previous
                                        </Button>

                                        <button
                                          type="submit"
                                          className="btn btn_red loginsubmit nextbtn ms-2"
                                          disabled={isLoading}
                                        >
                                          {isLoading ? "Submitting..." : "Submit"}
                                        </button>

                                      </div>
                                    </Col>
                                  </>
                                );
                              })()}
                            </Row>
                          </Form>
                        </div>
                        )
                      }) : (
                        <div>Loading step configuration...</div>
                      )}

                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {cropImgModalShow && (
            <ImageCropper
              show={cropImgModalShow}
              cropImg={cropImg}
              fileToImage={fileToImage}
              onHide={() => { setCropImgModalShow(false) }}
              centered
              size="xl"
              className="cropper-modal"
            />
          )}

          <PopupModalWithOk
            show={showPopup}
            onHide={handlePopupOk}
            message={popupMessage}
            showConfirm={false}
            staticBackdrop={true}
          />
        </>
      )}
    </>
  );
};

UpdateProfileStep5.propTypes = {
  title: PropTypes.string,
  superUserParams: PropTypes.object,
};

export default UpdateProfileStep5;